import * as React from 'react';

const TAG_GENERICO_SRC = '/icons/tag-generico.png';

type TagGenericoIconProps = Omit<
  React.ImgHTMLAttributes<HTMLImageElement>,
  'src' | 'width' | 'height'
>;

/** Brazilian generic-medicine badge — static PNG (avoid inlined data:image in SSR HTML). */
const TagGenericoIcon = ({
  className,
  alt = 'Medicamento genérico',
  ...props
}: TagGenericoIconProps) => (
  <img
    src={TAG_GENERICO_SRC}
    alt={alt}
    width={76}
    height={77}
    decoding="async"
    className={className}
    {...props}
  />
);

export default TagGenericoIcon;
